<template>
  <!--样式组件，适用于含头像，名字，副标题，一个按钮组成的样式-->
  <div class="des-container">
    <img class="avatar" :src="avatar || 'http://image.xinli001.com/images/avatar.jpg!80'" alt="壹心理直播-头像">
    <div class="author">
      <p class="name">{{ name | strLength(10) }}</p>
<!--      <p class="subheading">id:{{ channelId }}</p>-->
    </div>
    <div v-if="!hideBtn">
      <div v-if="!isFollow" class="oval-box1 func-btn" @click="handleAttention">{{ btnName }}</div>
      <div v-else class="oval-box2 func-btn" @click="handleAttention">
        <svg-icon icon-class="check" class-name="func-btn"></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AvatarNameCon",
    props: {
      avatar: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      btnName: {
        type: String,
        default: '关注'
      },
      isFollow: {
        type: Boolean,
        default: false
      },
      channelId: {
        type: Number,
        default: 0
      },
      hideBtn: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleAttention() {
        this.$emit('handleAttention')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  .des-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    padding: 6px 16px 6px 6px;
    width: fit-content;

    background-color: rgba(0, 0, 0, .3);
    border-radius: 40px;

    .avatar {
      margin-right: 20px;
      width: 68px;
      height: 68px;

      border-radius: 50%;
    }

    .author {
      display: flex;
      flex-direction: column;

      .name {
        line-height: 38px;

        @include overLine(1)
      }

      .subheading {
        font-size: 22px;
        color: rgba(255, 255, 255, .6);
      }
    }

    .oval-box1, .oval-box2 {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 18px;

      background-image: linear-gradient(-53deg, #FB5757 0%, #FF745B 100%);
      font-size: 22px;
    }

    .oval-box1 {
      width: 72px;
      height: 40px;
      border-radius: 20px;
      line-height: 40px;
    }

    .oval-box2 {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
</style>
